var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8a4775fe4514b24c0e8f672a51ea24440a605991"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["insiderfinance@insiderfinance"]={id:"8a4775fe4514b24c0e8f672a51ea24440a605991"};
      